document.addEventListener("DOMContentLoaded", function() {
  // Fallback pour closest() si non supporté
  if (!Element.prototype.closest) {
    Element.prototype.closest = function(s) {
      let el = this;
      do {
        if (el.matches(s)) return el;
        el = el.parentElement || el.parentNode;
      } while (el !== null && el.nodeType === 1);
      return null;
    };
  }

  const longTextSeoButtons = document.querySelectorAll(".long-text-seo-button");

  longTextSeoButtons.forEach(function(button) {
    button.addEventListener("click", function(e) {
      e.preventDefault();

      const container = this.closest('.long-text-container');
      const text = container.querySelector('.long-text-seo-content');
      container.classList.toggle("expand");
      text.classList.toggle("show");
      
      const buttonsContainer = this.closest('.readmore');
      const buttons = buttonsContainer.querySelectorAll('.long-text-seo-button');
      
      buttons.forEach(function(btn) {
        btn.classList.toggle("hidden");
      });
    });
  });
});